import { render, staticRenderFns } from "./MainTransuction.vue?vue&type=template&id=aef43b52&"
import script from "./MainTransuction.vue?vue&type=script&lang=js&"
export * from "./MainTransuction.vue?vue&type=script&lang=js&"
import style0 from "./MainTransuction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports